import React from 'react';
import { About } from '../components/About';
export function AboutPage() {
  return <main data-id="element-2255">
      <About data-id="element-2256" />
    </main>;
}